import { CareProType } from 'Components/CareProSearchDropdown/types';
import { SMILEY_CP_DETAILS } from 'Constants';
import React, { ReactElement } from 'react';
import './style.css';

export type preferredCPsListByServiceType = {
  home_personal_care?: Array<CareProType>;
  home_therapy?: Array<CareProType>;
  home_medical?: Array<CareProType>;
}

export type SelectPreferredCareProsPropsType = {
  onClickButton: () => void;
  showSelectPreferredCarePros: boolean;
  careProsList?: preferredCPsListByServiceType;
  thereAreHomePersonalCareServicesSelected: boolean;
  thereAreHomeTherapyServicesSelected: boolean;
  thereAreHomeMedicalServicesSelected: boolean;
  isReadOnlyMode: boolean | undefined;
  hideTheButton?: boolean;
}

const SelectPreferredCarePros = (props: SelectPreferredCareProsPropsType): ReactElement | null => {
  const {
    onClickButton,
    showSelectPreferredCarePros,
    careProsList,
    thereAreHomePersonalCareServicesSelected,
    thereAreHomeTherapyServicesSelected,
    thereAreHomeMedicalServicesSelected,
    isReadOnlyMode,
    hideTheButton
  } = props;

  const showSelectPreferredCPsButton = !isReadOnlyMode && !hideTheButton;

  const personalCareCPs = careProsList?.home_personal_care;
  const therapyCPs = careProsList?.home_therapy;
  const medicalCPs = careProsList?.home_medical;

  const _isButtonDisabled = (): boolean => {
    if (thereAreHomePersonalCareServicesSelected || thereAreHomeTherapyServicesSelected || thereAreHomeMedicalServicesSelected) {
      return false;
    }
    return true;
  };

  const _generateCareProLinkToSmileyV1 = (careProID: string) => {
    let url = '';
    url = SMILEY_CP_DETAILS + careProID;

    return url;
  };

  const _areTherePersonalCareCareProsToDisplay = (): boolean => {
    const thereArePersonalCareCPs = personalCareCPs && personalCareCPs.length > 0;
    return thereArePersonalCareCPs ? true : false;
  };

  const _areThereHomeTherapyCareProsToDisplay = (): boolean => {
    const thereAreTherapyCPs = therapyCPs && therapyCPs.length > 0;
    return thereAreTherapyCPs ? true : false;
  };

  const _areThereHomeMedicalCareProsToDisplay = (): boolean => {
    const thereAreMedicalCPs = medicalCPs && medicalCPs.length > 0;
    return thereAreMedicalCPs ? true : false;
  };

  const _renderPersonalCareCarePros = (): ReactElement | null => {
    if (_areTherePersonalCareCareProsToDisplay()) {
      return <div className='select-preferred-care-pro-list'>
        {personalCareCPs?.map((carePro, index) => _renderCareProName(carePro.first_name, carePro.last_name, index + 1, carePro.carepro_id, carePro.status))}
      </div>
    }
    return null;
  };

  const _renderHomeTherapyCarePros = (): ReactElement | null => {
    if (_areThereHomeTherapyCareProsToDisplay()) {
      return <div className='select-preferred-care-pro-list'>
        {therapyCPs?.map((carePro, index) => _renderCareProName(carePro.first_name, carePro.last_name, index + 1, carePro.carepro_id, carePro.status))}
      </div>
    }
    return null;
  };

  const _renderHomeMedicalCarePros = (): ReactElement | null => {
    if (_areThereHomeMedicalCareProsToDisplay()) {
      return <div className='select-preferred-care-pro-list'>
        {medicalCPs?.map((carePro, index) => _renderCareProName(carePro.first_name, carePro.last_name, index + 1, carePro.carepro_id, carePro.status))}
      </div>
    }
    return null;
  };

  const _renderButton = (): ReactElement | null => {
    if (showSelectPreferredCPsButton) {
      return (<button
        className='select-preferred-care-pro-button'
        onClick={() => onClickButton()}
        disabled={_isButtonDisabled()}
      >Select Preferred CP(s)</button>);
    }
    return null;
  };

  const _renderCareProName = (firstName: string, lastName: string, index: number, id: string, status: string): ReactElement => {
    const isInactive = status !== 'Approved';
    const inactiveText = isInactive ? '(Inactive)' : '';
    return <div className='select-preferred-care-pro-list-item' key={firstName + index}>
      {index}. <a
        onClick={() => window.open(_generateCareProLinkToSmileyV1(id), '_blank', 'noopener,noreferrer')}
      >{firstName} {lastName} {inactiveText}</a>
    </div>
  };

  const _renderCareProList = (): ReactElement | null => {

    if (thereAreHomePersonalCareServicesSelected) {
      return _renderPersonalCareCarePros();
    }

    if (thereAreHomeTherapyServicesSelected) {
      return _renderHomeTherapyCarePros();
    }

    if (thereAreHomeMedicalServicesSelected) {
      return _renderHomeMedicalCarePros();
    }

    return null;
  };

  const featureIsAllowed = true;

  if (showSelectPreferredCarePros && featureIsAllowed) {
    return (<div className='select-preferred-care-pro-container'>
      {_renderButton()}
      {_renderCareProList()}
    </div>)
  }

  return null;
};

export default SelectPreferredCarePros;